import userRoleFilter from 'app/filters/userRole'

import zipObject from 'lodash/zipObject'

export default class UserRole {

    static USER = 'USER';
    static ADMIN = 'ADMIN';
    static CONTRACTOR = 'CONTRACTOR';
    static WORKER = 'WORKER';
    static SUPPLIER = 'SUPPLIER';
    static SUPPLIER_ALTITUDE = 'SUPPLIER_ALTITUDE';
    static SUPPLIER_VIBRATION = 'SUPPLIER_VIBRATION';
    static ADVISOR = 'ADVISOR';
    static ADVISOR_EXTERNAL = 'ADVISOR_EXTERNAL';
    static RESIDENT = 'RESIDENT';

    static options(){

        const keys = Object.keys(UserRole);
        return zipObject(keys, keys.map(userRoleFilter));
    }
}